export const CONSENT_KEY = "safestart.consent";
const VERSION = 1;
const MAX_AGE_MS = 183 * 24 * 3600 * 1000;
export const CONSENT_EVENT = "safestart:consent";
export const OPEN_PREFS_EVENT = "safestart:open-consent";

export function readConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    if (!c || c.v !== VERSION || typeof c.analytics !== "boolean") return null;
    if (Date.now() - Date.parse(c.at) > MAX_AGE_MS) return null;
    return c;
  } catch {
    return null;
  }
}

function clearAnalyticsStorage() {
  Object.keys(localStorage).filter((k) => k.startsWith("ph_") || k.startsWith("__ph")).forEach((k) => localStorage.removeItem(k));
  Object.keys(sessionStorage).filter((k) => k.startsWith("ph_") || k.startsWith("__ph")).forEach((k) => sessionStorage.removeItem(k));
  const host = window.location.hostname;
  const domains = ["", host, `.${host}`, `.${host.split(".").slice(-2).join(".")}`];
  document.cookie.split(";").map((c) => c.split("=")[0].trim()).filter((n) => n.startsWith("ph_")).forEach((n) => {
    domains.forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/${d ? `; domain=${d}` : ""}`; });
  });
}

function applyConsent(analytics) {
  if (analytics) {
    window.__safestartAnalyticsInit?.();
    return;
  }
  const ph = window.posthog;
  if (window.__ssAnalyticsOn && ph) {
    ph.opt_out_capturing?.();
    ph.stopSessionRecording?.();
    ph.set_config?.({ disable_persistence: true });
  }
  clearAnalyticsStorage();
}

const purgeIfNotConsented = () => {
  if (readConsent()?.analytics !== true) clearAnalyticsStorage();
};
purgeIfNotConsented();
window.addEventListener("pagehide", purgeIfNotConsented);

export function saveConsent(analytics) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ v: VERSION, analytics, at: new Date().toISOString() }));
  applyConsent(analytics);
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export const openConsentPreferences = () => window.dispatchEvent(new Event(OPEN_PREFS_EVENT));
